// extracted by mini-css-extract-plugin
export default {"bio":"profileBio_bio__MWvo0"};